import React, { useState, useEffect } from 'react';
import SearchFieldsSelect, { useSearchFields, getSearchFieldsPlaceholder } from '../../Components/SearchFieldsSelect/SearchFieldsSelect';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Table, Input, Space, Button, Typography, Tag, Select, DatePicker, Badge, Card, Tooltip, message, Avatar, Statistic, Row, Col, InputNumber, Modal, Form, Divider } from 'antd';
import { 
    CalendarOutlined, 
    EyeOutlined, 
    PhoneOutlined, 
    ReloadOutlined, 
    SearchOutlined, 
    UserSwitchOutlined,
    FilterOutlined,
    ClearOutlined,
    DollarOutlined,
    CreditCardOutlined,
    WalletOutlined,
    AccountBookOutlined,
    CheckOutlined,
    CloseOutlined,
    StopOutlined,
    EditOutlined,
    UserOutlined,
    TeamOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    ShoppingOutlined,
    ClockCircleOutlined,
    MailOutlined,
    SyncOutlined,
    CommentOutlined,
    FileTextOutlined,
    HistoryOutlined
} from '@ant-design/icons';
import API from '../../API/API';
import { TbCircleDottedLetterQ } from 'react-icons/tb';
import { ROUTES } from '../../Routes/Routes';
import { motion } from 'framer-motion';
import { isPartStatusUnset } from '../../utils/orderStatus';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const AdvancePayment = () => {
    const navigate = useNavigate();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
const [dateRange, setDateRange] = useState(() => {
    return [dayjs().startOf('month'), dayjs().endOf('month')];
});
    const [loginAgent, setLoginAgent] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [allFilteredLeads, setAllFilteredLeads] = useState([]);
const [specificationModalVisible, setSpecificationModalVisible] = useState(false);
const [selectedLeadForSpecification, setSelectedLeadForSpecification] = useState(null);
const [tempSpecification, setTempSpecification] = useState('');
const [savingSpecification, setSavingSpecification] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    // The search a request uses: the box's text, set 0.5 s after typing pauses
    // (at once when the box is cleared), so a search is not sent per keystroke.
    const [searchQuery, setSearchQuery] = useState('');
    useEffect(() => {
        const trimmed = searchTerm.trim();
        if (!trimmed) {
            setSearchQuery('');
            return undefined;
        }
        const timer = setTimeout(() => setSearchQuery(trimmed), 500);
        return () => clearTimeout(timer);
    }, [searchTerm]);
    const [searchFields, setSearchFields] = useSearchFields('advance-payment:search-fields');
    // The "Search in" group only changes the results of a search, so changing it
    // with an empty search box sends no request.
    const effectiveSearchFields = searchQuery ? searchFields : null;
    const [calledLeads, setCalledLeads] = useState(new Set());
    const [quickFilter, setQuickFilter] = useState('currentMonth');
    const [editingSpecification, setEditingSpecification] = useState(null);
const [editingSpecValue, setEditingSpecValue] = useState('');
const [updatingSpecification, setUpdatingSpecification] = useState(false);
 
    // Agent filter state
    const [agents, setAgents] = useState([]);
    const [selectedAgentId, setSelectedAgentId] = useState(null);
    const [editingPendingPaymentId, setEditingPendingPaymentId] = useState(null);
    const [editingPendingPaymentDate, setEditingPendingPaymentDate] = useState(null);
    const [savingPendingPayment, setSavingPendingPayment] = useState(false);
    const [partStatusModalVisible, setPartStatusModalVisible] = useState(false);
const [selectedLeadForPartStatus, setSelectedLeadForPartStatus] = useState(null);
const [tempPartStatus, setTempPartStatus] = useState('');
const [tempPartStatusDate, setTempPartStatusDate] = useState(null);
const [savingPartStatusManual, setSavingPartStatusManual] = useState(false);


const [serviceAgentModalVisible, setServiceAgentModalVisible] = useState(false);
const [selectedLeadForServiceAgent, setSelectedLeadForServiceAgent] = useState(null);
const [selectedServiceAgentForLead, setSelectedServiceAgentForLead] = useState(null);
const [savingServiceAgent, setSavingServiceAgent] = useState(false);
    // Modal state for Re-Quoted
    const [isRequoteModalVisible, setIsRequoteModalVisible] = useState(false);
    const [selectedLeadForRequote, setSelectedLeadForRequote] = useState(null);
    const [requoteAmount, setRequoteAmount] = useState(null);
    const [savingRequote, setSavingRequote] = useState(false);
    const [requoteForm] = Form.useForm();
const [serviceAgentsMap, setServiceAgentsMap] = useState({});
const [loadingServiceAgents, setLoadingServiceAgents] = useState(false);
const [selectedServiceAgentId, setSelectedServiceAgentId] = useState(null);
    // Filter state
    const [filteredInfo, setFilteredInfo] = useState({
        partStatus: null,
        agent: null
    });

    // Payment statistics
    const [paymentStats, setPaymentStats] = useState({
        totalAmount: 0,
        totalPaid: 0,
        totalBalance: 0,
        collectionRate: 0,
        avgPayment: 0
    });

    // Editing states for Part Status
    const [editingId, setEditingId] = useState(null);
    const [editingValue, setEditingValue] = useState('');
    const [savingPartStatus, setSavingPartStatus] = useState(false);
const [commentsModalVisible, setCommentsModalVisible] = useState(false);
const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
const [newComment, setNewComment] = useState('');
const [addingComment, setAddingComment] = useState(false);
const [historyModalVisible, setHistoryModalVisible] = useState(false);
const [selectedLeadForHistory, setSelectedLeadForHistory] = useState(null);
    const isAdmin = loginAgent?.role === "ADMIN";

useEffect(() => {
    const UD = localStorage.getItem('userData');
    if (!UD) {
        navigate(ROUTES?.LOGIN);
        return;
    }
    const parsedUser = JSON.parse(UD);
    setLoginAgent(parsedUser);
    
    if (parsedUser?.role === "ADMIN") {
        fetchAgents();
    }
    fetchServiceAgents(); // Add this line - fetch for all users
}, [navigate]);

const handleUpdateSpecification = async (leadId, newSpecification) => {
    if (!leadId) return;
    
    const trimmedValue = newSpecification?.trim() || '';
    
    if (trimmedValue.length > 2000) {
        message.warning('Specification cannot exceed 2000 characters');
        return;
    }
    
    setUpdatingSpecification(true);
    try {
        // First, get the current lead data to preserve other vehicleInfo fields
        const currentLead = leads.find(lead => lead._id === leadId);
        const currentVehicleInfo = currentLead?.vehicleInfo || {};
        
        // Merge the specification with existing vehicleInfo
        const payload = {
            vehicleInfo: {
                ...currentVehicleInfo, // Preserve all existing fields
                specification: trimmedValue // Update only specification
            }
        };
        
        console.log('Sending payload with preserved data:', payload);
        
        const response = await API.UpdateLead(leadId, payload);
        
        if (response?.status) {
            message.success('Specification updated successfully!');
            fetchLeads(); // Refresh the leads list
        } else {
            message.error(response?.message || 'Failed to update specification');
        }
    } catch (error) {
        console.error('Error updating specification:', error);
        message.error('Failed to update specification');
    } finally {
        setUpdatingSpecification(false);
        setEditingSpecification(null);
        setEditingSpecValue('');
    }
};
// Add these functions with your other helper functions (around line 300)
// Handle opening the specification edit modal
const handleSpecificationEdit = (record) => {
    const currentSpec = record.vehicleInfo?.specification || '';
    setSelectedLeadForSpecification(record);
    setTempSpecification(currentSpec);
    setSpecificationModalVisible(true);
};

// Handle saving the specification
const handleSpecificationSave = async () => {
    if (!selectedLeadForSpecification) return;
    
    setSavingSpecification(true);
    
    try {
        const payload = {
            vehicleInfo: {
                ...selectedLeadForSpecification.vehicleInfo,
                specification: tempSpecification.trim() || ''
            }
        };
        
        const response = await API.UpdateLead(selectedLeadForSpecification._id, payload);
        
        if (response?.status) {
            message.success('Vehicle specification updated successfully!');
            
            // Update local state
            setLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === selectedLeadForSpecification._id ? { 
                        ...lead, 
                        vehicleInfo: {
                            ...lead.vehicleInfo,
                            specification: tempSpecification.trim() || ''
                        }
                    } : lead
                )
            );
            
            // Also update allFilteredLeads if needed
            setAllFilteredLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === selectedLeadForSpecification._id ? { 
                        ...lead, 
                        vehicleInfo: {
                            ...lead.vehicleInfo,
                            specification: tempSpecification.trim() || ''
                        }
                    } : lead
                )
            );
            
            // Close modal
            setSpecificationModalVisible(false);
            setSelectedLeadForSpecification(null);
            setTempSpecification('');
        } else {
            message.error(response?.message || 'Failed to update specification');
        }
    } catch (error) {
        console.error('Error updating specification:', error);
        message.error('Failed to save specification');
    } finally {
        setSavingSpecification(false);
    }
};
// Handle opening the service agent selection modal
const handleServiceAgentEdit = (record) => {
    const currentServiceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    setSelectedLeadForServiceAgent(record);
    setSelectedServiceAgentForLead(currentServiceAgentId || null);
    setServiceAgentModalVisible(true);
};

// Handle saving the service agent
const handleServiceAgentSave = async () => {
    if (!selectedLeadForServiceAgent) return;
    
    setSavingServiceAgent(true);
    
    try {
        const payload = {
            orderServiceHandledBy: selectedServiceAgentForLead || null // Set to null if unassigned
        };
        
        const response = await API.UpdateLead(selectedLeadForServiceAgent._id, payload);
        
        if (response?.status) {
            message.success(selectedServiceAgentForLead ? 'Service agent assigned successfully!' : 'Service agent unassigned successfully!');
            
            // Update local state
            setLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === selectedLeadForServiceAgent._id ? { 
                        ...lead, 
                        orderServiceHandledBy: selectedServiceAgentForLead
                    } : lead
                )
            );
            
            // Close modal
            setServiceAgentModalVisible(false);
            setSelectedLeadForServiceAgent(null);
            setSelectedServiceAgentForLead(null);
            
            // Refresh leads to get populated agent data
            fetchLeads();
            fetchServiceAgents(); // Refresh the agents map
        } else {
            message.error(response?.message || 'Failed to assign service agent');
        }
    } catch (error) {
        console.error('Error assigning service agent:', error);
        message.error('Failed to save service agent assignment');
    } finally {
        setSavingServiceAgent(false);
    }
};

const handlePartStatusEditStart = (record) => {
    const currentStatus = record.ShipmentTracking?.partStatus || 
                         record.orderProcessComplete?.partStatus || 
                         'No';
    
    // Get current part status date if exists
    const partStatusHistory = record.ShipmentTrackingHistory
        ?.filter(history => history.field === 'ShipmentTracking.partStatus')
        .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0];
    
    const currentDate = partStatusHistory?.changedAt ? dayjs(partStatusHistory.changedAt) : dayjs();
    
    setSelectedLeadForPartStatus(record);
    setTempPartStatus(currentStatus);
    setTempPartStatusDate(currentDate);
    setPartStatusModalVisible(true);
};

const handlePartStatusManualUpdate = async () => {
    if (!tempPartStatus) {
        message.warning('Please select a part status');
        return;
    }

    if (!tempPartStatusDate) {
        message.warning('Please select a date');
        return;
    }

    setSavingPartStatusManual(true);

    try {
        const currentLead = selectedLeadForPartStatus;
        
        // Get the OLD value from the current lead
        const oldValue = currentLead.ShipmentTracking?.partStatus || 'Not Available';
        
        // Create new history entry with BOTH old and new values
        const newHistoryEntry = {
            field: 'ShipmentTracking.partStatus',
            oldValue: oldValue,  // ✅ Include old value
            newValue: tempPartStatus,
            changedAt: tempPartStatusDate.toISOString()
        };

        const existingHistory = currentLead.ShipmentTrackingHistory || [];
        
        const payload = {
            ShipmentTracking: {
                ...currentLead?.ShipmentTracking,
                partStatus: tempPartStatus
            },
            ShipmentTrackingHistory: [...existingHistory, newHistoryEntry]
        };

        const response = await API.UpdateLead(currentLead._id, payload);

        if (response?.status) {
            message.success('Part status updated successfully with manual date!');
            const updatedLead = response.data;
            
            // Update local state
            setLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === currentLead._id ? (updatedLead ? {
                        ...lead,
                        ...updatedLead
                    } : {
                        ...lead,
                        ShipmentTracking: {
                            ...lead.ShipmentTracking,
                            partStatus: tempPartStatus
                        },
                        ShipmentTrackingHistory: [...(lead.ShipmentTrackingHistory || []), newHistoryEntry]
                    }) : lead
                )
            );
            setAllFilteredLeads(prevLeads =>
                prevLeads.map(lead =>
                    lead._id === currentLead._id ? (updatedLead ? {
                        ...lead,
                        ...updatedLead
                    } : {
                        ...lead,
                        ShipmentTracking: {
                            ...lead.ShipmentTracking,
                            partStatus: tempPartStatus
                        },
                        ShipmentTrackingHistory: [...(lead.ShipmentTrackingHistory || []), newHistoryEntry]
                    }) : lead
                )
            );

            if (updatedLead && selectedLeadForHistory?._id === currentLead._id) {
                setSelectedLeadForHistory(prev => ({ ...prev, ...updatedLead }));
            }
            
            // Close modal and reset
            setPartStatusModalVisible(false);
            setSelectedLeadForPartStatus(null);
            setTempPartStatus('');
            setTempPartStatusDate(null);
        } else {
            message.error(response?.message || 'Failed to update part status');
        }
    } catch (error) {
        console.error('Error updating part status:', error);
        message.error('Failed to save part status');
    } finally {
        setSavingPartStatusManual(false);
    }
};
const handleAddComment = async () => {
    if (!newComment.trim()) {
        message.warning('Please enter a comment');
        return;
    }

    if (!selectedLeadForComment) return;

    setAddingComment(true);
    try {
        const existingComments = selectedLeadForComment.advancePaymentPageComment || [];
        const payload = {
            advancePaymentPageComment: [
                ...existingComments,
                {
                    comment: newComment.trim(),
                    changedAt: new Date().toISOString()
                }
            ]
        };

        const response = await API.UpdateLead(selectedLeadForComment._id, payload);

        if (response?.status) {
            message.success('Comment added successfully!');
            setNewComment('');
            setCommentsModalVisible(false);
            setSelectedLeadForComment(null);
            // Refresh the leads list
            fetchLeads();
        } else {
            message.error(response?.message || 'Failed to add comment');
        }
    } catch (error) {
        console.error('Error adding comment:', error);
        message.error('Failed to add comment');
    } finally {
        setAddingComment(false);
    }
};
const formatCommentDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
};
// Add this function with your other helper functions
const getServiceAgentName = (record) => {
    const serviceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    if (!serviceAgentId) return null;
    
    // Check if already populated as object
    if (record.orderServiceHandledBy && typeof record.orderServiceHandledBy === 'object') {
        return `${record.orderServiceHandledBy.firstName || ''} ${record.orderServiceHandledBy.lastName || ''}`.trim() || 
               record.orderServiceHandledBy.userName || 'Service Agent';
    }
    
    // Check in our map
    const agentInfo = serviceAgentsMap[serviceAgentId];
    return agentInfo?.name || null;
};


    const handlePendingPaymentDateUpdate = async (id) => {
        if (!editingPendingPaymentDate) {
            message.warning('Please select a date');
            return;
        }

        setSavingPendingPayment(true);

        try {
            const currentLead = leads.find(lead => lead._id === id);
            const existingHistory = currentLead?.leadStageHistory || [];
            
            // Find the index of 'Sales Made' stage
            const pendingIndex = existingHistory.findIndex(
                stage => stage.stage === 'Sales Made'
            );
            
            let updatedHistory;
            
            // Set to start of day (00:00:00) for date-only
            const dateOnly = editingPendingPaymentDate.startOf('day').toISOString();
            
            if (pendingIndex !== -1) {
                // Update existing Sales Made entry
                updatedHistory = [...existingHistory];
                updatedHistory[pendingIndex] = {
                    ...updatedHistory[pendingIndex],
                    changedAt: dateOnly
                };
            } else {
                // Add new Sales Made entry if doesn't exist
                updatedHistory = [
                    ...existingHistory,
                    {
                        stage: 'Sales Made',
                        changedAt: dateOnly
                    }
                ];
            }
            
            const payload = {
                leadStageHistory: updatedHistory
            };

            const response = await API.UpdateLead(id, payload);

            if (response?.status) {
                message.success('Sales Made date updated successfully!');
                const updatedLead = response.data;
                
                // Update local state
                setLeads(prevLeads => 
                    prevLeads.map(lead => 
                        lead._id === id ? (updatedLead ? {
                            ...lead,
                            ...updatedLead
                        } : {
                            ...lead,
                            leadStageHistory: updatedHistory
                        }) : lead
                    )
                );
                setAllFilteredLeads(prevLeads =>
                    prevLeads.map(lead =>
                        lead._id === id ? (updatedLead ? {
                            ...lead,
                            ...updatedLead
                        } : {
                            ...lead,
                            leadStageHistory: updatedHistory
                        }) : lead
                    )
                );

                if (updatedLead && selectedLeadForHistory?._id === id) {
                    setSelectedLeadForHistory(prev => ({ ...prev, ...updatedLead }));
                }
                
                // Reset editing states
                setEditingPendingPaymentId(null);
                setEditingPendingPaymentDate(null);
            } else {
                message.error(response?.message || 'Failed to update pending payment date');
            }
        } catch (error) {
            console.error('Error updating pending payment date:', error);
            message.error('Failed to save pending payment date');
        } finally {
            setSavingPendingPayment(false);
        }
    };

    const handlePendingPaymentEditStart = (record) => {
        const pendingPaymentStage = record.leadStageHistory?.find(
            stage => stage.stage === 'Sales Made'
        );
        const currentDate = pendingPaymentStage?.changedAt || null;
        
        setEditingPendingPaymentId(record._id);
        setEditingPendingPaymentDate(currentDate ? dayjs(currentDate) : dayjs());
    };

    const handlePendingPaymentEditCancel = () => {
        setEditingPendingPaymentId(null);
        setEditingPendingPaymentDate(null);
    };

    // Handle Re-Quoted modal open
    const handleRequoteOpen = (record) => {
        setSelectedLeadForRequote(record);
        setRequoteAmount(record.totalAmount || 0);
        requoteForm.setFieldsValue({
            totalAmount: record.totalAmount || 0
        });
        setIsRequoteModalVisible(true);
    };

    // Handle Re-Quoted modal cancel
    const handleRequoteCancel = () => {
        setIsRequoteModalVisible(false);
        setSelectedLeadForRequote(null);
        setRequoteAmount(null);
        requoteForm.resetFields();
    };

    // Handle Re-Quoted save
    const handleRequoteSave = async () => {
        try {
            const values = await requoteForm.validateFields();
            
            if (!values.totalAmount || values.totalAmount <= 0) {
                message.warning('Please enter a valid amount');
                return;
            }

            setSavingRequote(true);
            
            const currentLead = selectedLeadForRequote;
            const currentPaidAmount = currentLead?.paidAmount || 0;
            
            // Calculate new balance
            const newBalance = values.totalAmount - currentPaidAmount;
            
            const payload = {
                totalAmount: values.totalAmount,
                balanceDue: newBalance >= 0 ? newBalance : 0
            };

            const response = await API.UpdateLead(currentLead._id, payload);

            if (response?.status) {
                message.success('Total amount updated successfully!');
                const updatedLead = response.data;
                
                // Update local state
                setLeads(prevLeads => 
                    prevLeads.map(lead => 
                        lead._id === currentLead._id ? (updatedLead ? {
                            ...lead,
                            ...updatedLead
                        } : {
                            ...lead,
                            totalAmount: values.totalAmount,
                            balanceDue: newBalance >= 0 ? newBalance : 0
                        }) : lead
                    )
                );
                
                // Recalculate statistics: the totals cover every listed lead,
                // so they change by the difference this one lead made.
                const oldLead = leads.find(lead => lead._id === currentLead._id) || currentLead;
                const newLead = updatedLead
                    ? { ...oldLead, ...updatedLead }
                    : { ...oldLead, totalAmount: values.totalAmount };
                const totals = paymentTotalsRef.current;
                applyPaymentTotals({
                    totalAmount: totals.totalAmount - (oldLead.totalAmount || 0) + (newLead.totalAmount || 0),
                    totalPaid: totals.totalPaid - getCompletedAdvancePaidAmount(oldLead) + getCompletedAdvancePaidAmount(newLead),
                    totalBalance: totals.totalBalance - getOutstandingBalance(oldLead) + getOutstandingBalance(newLead),
                    count: totals.count
                });

                if (updatedLead && selectedLeadForHistory?._id === currentLead._id) {
                    setSelectedLeadForHistory(prev => ({ ...prev, ...updatedLead }));
                }
                
                // Close modal
                handleRequoteCancel();
            } else {
                message.error(response?.message || 'Failed to update total amount');
            }
        } catch (error) {
            console.error('Error updating total amount:', error);
            message.error('Failed to save total amount');
        } finally {
            setSavingRequote(false);
        }
    };

    const fetchAgents = async () => {
        try {
            const response = await API.userGetAll();
            if (response?.success) {
                const salesAgents = (response.data || []).filter(user => user.role === "SALES-AGENT");
                setAgents(salesAgents);
            }
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    };
// Add this function with your other fetch functions
const fetchServiceAgents = async () => {
    setLoadingServiceAgents(true);
    try {
        const response = await API.getServiceAgents();
        if (response?.success) {
            const agentsMap = {};
            // Get all users with SERVICE-AGENT or SUPPORT-AGENT role
            const serviceAgentsList = (response.data || []).filter(
                user => user.role === "SERVICE-AGENT" || user.role === "SUPPORT-AGENT"
            );
            serviceAgentsList.forEach(agent => {
                agentsMap[agent._id] = {
                    name: `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || agent.userName || agent.email,
                    email: agent.email,
                    phone: agent.directNumber,
                    role: agent.role
                };
            });
            setServiceAgentsMap(agentsMap);
        }
    } catch (error) {
        console.error("Failed to fetch service agents", error);
    } finally {
        setLoadingServiceAgents(false);
    }
};
    // Get agent name function
    const getAgentName = (record) => {
        if (record.assignedAgent?.name) return record.assignedAgent.name;
        if (record.agentName) return record.agentName;
        if (record.handledBy?.firstName && record.handledBy?.lastName) {
            return `${record.handledBy.firstName} ${record.handledBy.lastName}`;
        }
        if (record.handledBy?.name) return record.handledBy.name;
        return 'Unassigned';
    };

    // Get unique agents for filter
    const getUniqueAgents = () => {
        const agentNames = leads
            .map(lead => getAgentName(lead))
            .filter((value, index, self) => value && self.indexOf(value) === index);
        return agentNames;
    };

    // Quick filter options
    const handleQuickFilter = (value) => {
        setQuickFilter(value);
        let newDateRange;
        
        switch(value) {
            case 'today':
                newDateRange = [dayjs().startOf('day'), dayjs().endOf('day')];
                break;
            case 'yesterday':
                newDateRange = [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')];
                break;
            case 'thisWeek':
                newDateRange = [dayjs().startOf('week'), dayjs().endOf('week')];
                break;
            case 'lastWeek':
                newDateRange = [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')];
                break;
            case 'currentMonth':
                newDateRange = [dayjs().startOf('month'), dayjs().endOf('month')];
                break;
            case 'lastMonth':
                newDateRange = [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')];
                break;
            case 'thisYear':
                newDateRange = [dayjs().startOf('year'), dayjs().endOf('year')];
                break;
            default:
                newDateRange = dateRange;
        }
        
        setDateRange(newDateRange);
        setCurrentPage(1);
    };

    const getCompletedAdvancePaidAmount = (lead) => {
        return (lead.advancePayments || []).reduce((sum, payment) => {
            if (payment?.status === 'Completed' && Number(payment?.amount) > 0) {
                return sum + Number(payment.amount);
            }
            return sum;
        }, 0);
    };

    const getOutstandingBalance = (lead) => {
        const total = Number(lead.totalAmount || 0);
        const paid = getCompletedAdvancePaidAmount(lead);
        return Math.max(0, total - paid);
    };

    const hasPendingPaymentHistory = (lead) => {
        return lead.leadStageHistory?.some(stage => stage.stage === 'Pending Payment');
    };

    const shouldShowInAdvancePayment = (lead) => {
        const balance = getOutstandingBalance(lead);
        if (balance <= 0) return false;

        if (lead.leadStage === 'Pending Payment') return true;

        return lead.leadStage === 'Sales Made' &&
            hasPendingPaymentHistory(lead) &&
            getCompletedAdvancePaidAmount(lead) > 0;
    };

    // The server sends the page's totals over every listed lead (not just this
    // page): totalAmount, totalPaid, totalBalance and count. The cards are
    // worked out from them exactly as calculatePaymentStats did.
    const paymentTotalsRef = React.useRef({ totalAmount: 0, totalPaid: 0, totalBalance: 0, count: 0 });
    const applyPaymentTotals = (totals) => {
        const safe = {
            totalAmount: Number(totals?.totalAmount) || 0,
            totalPaid: Number(totals?.totalPaid) || 0,
            totalBalance: Number(totals?.totalBalance) || 0,
            count: Number(totals?.count) || 0
        };
        paymentTotalsRef.current = safe;
        const collectionRate = safe.totalAmount > 0
            ? (safe.totalPaid / safe.totalAmount * 100).toFixed(1)
            : 0;
        const avgPayment = safe.totalPaid > 0 ? safe.totalPaid / safe.count : 0;
        setPaymentStats({
            totalAmount: safe.totalAmount,
            totalPaid: safe.totalPaid,
            totalBalance: safe.totalBalance,
            collectionRate,
            avgPayment
        });
    };

    // Calculate payment statistics
    const calculatePaymentStats = (data) => {
        const stats = data.reduce((acc, lead) => {
            const total = lead.totalAmount || 0;
            const paid = getCompletedAdvancePaidAmount(lead);
            const balance = getOutstandingBalance(lead);
            
            return {
                totalAmount: acc.totalAmount + total,
                totalPaid: acc.totalPaid + paid,
                totalBalance: acc.totalBalance + balance
            };
        }, { totalAmount: 0, totalPaid: 0, totalBalance: 0 });

        const collectionRate = stats.totalAmount > 0 
            ? (stats.totalPaid / stats.totalAmount * 100).toFixed(1)
            : 0;
        const avgPayment = stats.totalPaid > 0 ? stats.totalPaid / data.length : 0;

        setPaymentStats({
            ...stats,
            collectionRate,
            avgPayment
        });
    };

 const fetchLeads = async () => {
    setLoading(true);
    try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        if (!userData?.id) {
            setLoading(false);
            return;
        }

        // The server picks, sorts and counts the Advance Payment leads with the
        // page's rules and sends back only this page plus the stats totals
        // (LeadController getAll, view=advance-payment).
        const isSearching = Boolean(searchQuery);
        const effectiveDateRange =
            dateRange && dateRange[0] && dateRange[1]
                ? dateRange
                : [dayjs().startOf('month'), dayjs().endOf('month')];
        const params = {
            view: 'advance-payment',
            page: currentPage,
            limit: pageSize,
            status: "Pending Payment,Sales Made",
            advancePaymentFrom: effectiveDateRange[0].startOf('day').valueOf(),
            advancePaymentTo: effectiveDateRange[1].endOf('day').valueOf(),
        };

        if (isSearching) { params.search = searchQuery; params.searchFields = searchFields; }
        if (filteredInfo.partStatus?.length > 0) params.partStatus = filteredInfo.partStatus.join(',');
        if (isAdmin && selectedAgentId) params.agentId = selectedAgentId;

        const response = await API.leadGetAll(params);

        if (response?.status) {
            setLeads(response.data || []);
            setTotalRecords(response.pagination?.totalRecords || 0);
            applyPaymentTotals(response.advancePaymentStats);
        } else {
            setLeads([]);
            setTotalRecords(0);
            applyPaymentTotals(null);
        }
    } catch (error) {
        console.error('Failed to fetch leads:', error);
        setLeads([]);
    } finally {
        setLoading(false);
    }
};
    const handleEditStart = (record) => {
        const currentStatus = record.ShipmentTracking?.partStatus || 
                             record.orderProcessComplete?.partStatus || 
                             'Not Available';
        setEditingId(record._id);
        setEditingValue(currentStatus);
    };

    const handleEditCancel = () => {
        setEditingId(null);
        setEditingValue('');
    };

useEffect(() => {
    fetchLeads();
}, [currentPage, pageSize, dateRange, searchQuery, effectiveSearchFields, filteredInfo.partStatus, selectedAgentId, selectedServiceAgentId]);

const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
};

const handlePageSizeChange = (current, size) => {
    setCurrentPage(1);
    setPageSize(size);
};

   const clearFilters = () => {
    setSearchTerm("");
    // Always set a valid date range
    setDateRange([dayjs().startOf('month'), dayjs().endOf('month')]);
    setQuickFilter('currentMonth');
    setFilteredInfo({ partStatus: null, agent: null });
    setSelectedAgentId(null);
    setCurrentPage(1);
    message.info('All filters cleared');
};
const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    // page/size handled by pagination onChange
};

    const leadStageColors = {
        'New': { color: '#1890ff', background: '#e6f7ff' },
        'Call Back': { color: '#faad14', background: '#fffbe6' },
        'Voice Mail': { color: '#9254de', background: '#f9f0ff' },
        'Follow-Up': { color: '#fa8c16', background: '#fff7e6' },
        'Quoted': { color: '#13c2c2', background: '#e6fffb' },
        'Negotiation': { color: '#eb2f96', background: '#fff0f6' },
        'Payment Completed': { color: '#52c41a', background: '#f6ffed' },
        'Sales Made': { color: '#389e0d', background: '#f6ffed' },
        'Part Not Available': { color: '#bfbfbf', background: '#fafafa' },
        'Wrong Number': { color: '#ff4d4f', background: '#fff1f0' },
        'Not Interested': { color: '#d46b08', background: '#fff7e6' },
        'Hang Up': { color: '#8c8c8c', background: '#f5f5f5' },
        'Fake': { color: '#a8071a', background: '#fff1f0' },
        'Test Lead': { color: '#7cb305', background: '#fcffe6' },
    };

    const getPartStatusConfig = (status) => {
        const configs = {
            'Available': { 
                color: '#52c41a', 
                icon: <CheckOutlined />, 
                text: 'Available' 
            },
            'Not Available': { 
                color: '#ff4d4f', 
                icon: <CloseOutlined />, 
                text: 'Not Available' 
            },
            'Not Good': { 
                color: '#faad14', 
                icon: <StopOutlined />, 
                text: 'Not Good' 
            },
            'Wrong Part': { 
                color: '#fa8c16', 
                icon: <CloseOutlined />, 
                text: 'Wrong Part' 
            },
            'Customer Canceled Order': { 
                color: '#8c8c8c', 
                icon: <StopOutlined />, 
                text: 'Customer Canceled Order' 
            },
            'No': { 
                color: '#bfbfbf', 
                icon: <CloseOutlined />, 
                text: 'No' 
            }
        };
        return configs[status] || configs['Not Available'];
    };

    function formatToPST(isoDateString) {
        if (!isoDateString) return 'N/A';
        const date = new Date(isoDateString);
        const options = {
            timeZone: 'America/Los_Angeles',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };
        return date.toLocaleString('en-US', options);
    }

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    const getStageDate = (record, stageName) => {
        const stage = record.leadStageHistory?.find(s => s.stage === stageName);
        return stage?.changedAt || null;
    };
// Add this helper function outside your component
const getLastManualPartStatusChange = (record) => {
    const history = record.ShipmentTrackingHistory || [];
    
    // Filter for partStatus changes that have BOTH oldValue and newValue
    const manualChanges = history.filter(entry => 
        entry.field === 'ShipmentTracking.partStatus' &&
        entry.oldValue !== undefined && 
        entry.newValue !== undefined &&
        entry.oldValue !== entry.newValue // Ignore no-change entries
    );
    
    // Sort by date (newest first) and return the first one
    const sortedChanges = [...manualChanges].sort((a, b) => 
        new Date(b.changedAt) - new Date(a.changedAt)
    );
    
    return sortedChanges[0] || null;
};

const getHistoryTimestamp = (dateValue) => {
    const timestamp = new Date(dateValue || 0).getTime();
    return Number.isFinite(timestamp) ? timestamp : 0;
};

const sortHistoryNewestFirst = (items, dateSelector) => {
    return [...(items || [])].filter(Boolean).sort((a, b) => (
        getHistoryTimestamp(dateSelector(b)) - getHistoryTimestamp(dateSelector(a))
    ));
};

const formatHistoryDate = (dateValue) => {
    if (!dateValue) return 'N/A';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return 'N/A';

    return date.toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

const sanitizeHistoryText = (value, fallback = 'N/A') => {
    if (value === null || value === undefined || value === '') return fallback;
    return String(value).replace(/\b[a-f\d]{24}\b/gi, 'user');
};

const getPaymentStatusColor = (status) => {
    switch ((status || '').toLowerCase()) {
        case 'completed': return 'green';
        case 'pending': return 'orange';
        case 'failed': return 'red';
        case 'refunded':
        case 'partially refunded': return 'purple';
        case 'cancelled': return 'default';
        default: return 'blue';
    }
};

const getServiceAgentAuditEntries = (lead) => {
    return sortHistoryNewestFirst(
        (lead?.audit || []).filter(entry => {
            const action = String(entry?.action || '').toUpperCase();
            const details = String(entry?.details || '').toLowerCase();
            return action.includes('SERVICE_AGENT') || details.includes('service agent');
        }),
        entry => entry.timestamp
    );
};

const getPartStatusHistoryEntries = (lead) => {
    return sortHistoryNewestFirst(
        (lead?.ShipmentTrackingHistory || []).filter(entry => (
            entry?.field === 'ShipmentTracking.partStatus' &&
            entry.oldValue !== entry.newValue
        )),
        entry => entry.changedAt
    );
};

const getPaymentStageHistoryEntries = (lead) => {
    return sortHistoryNewestFirst(
        (lead?.leadStageHistory || []).filter(entry => (
            entry?.stage === 'Pending Payment' || entry?.stage === 'Sales Made'
        )),
        entry => entry.changedAt
    );
};

const getRequotedHistoryEntries = (lead) => {
    const ascendingQuotes = sortHistoryNewestFirst(lead?.quotedValue, quote => quote.addedAt).reverse();
    return ascendingQuotes
        .map((quote, index) => ({
            ...quote,
            previousPrice: ascendingQuotes[index - 1]?.price
        }))
        .reverse();
};

const isRawObjectId = (value) => (
    typeof value === 'string' && /^[a-f\d]{24}$/i.test(value)
);

const getActorName = (actor) => {
    if (!actor) return null;

    if (typeof actor === 'string') {
        return isRawObjectId(actor) ? null : actor;
    }

    const fullName = [actor.firstName, actor.lastName].filter(Boolean).join(' ').trim();
    return fullName || actor.fullName || actor.name || actor.userName || null;
};

const getHistoryActorName = (entry, actorFields) => {
    for (const field of actorFields) {
        const actorName = getActorName(entry?.[field]);
        if (actorName) return actorName;
    }
    return null;
};

const renderActorLine = (label, actorName) => (
    <Text type="secondary" style={{ display: 'block', fontSize: 12, marginTop: 6 }}>
        {label}: {actorName || 'Unknown'}
    </Text>
);

const renderHistorySection = (title, items, renderItem, emptyText) => (
    <div style={{ marginBottom: 18 }}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 8
        }}>
            <Text strong>{title}</Text>
            <Tag color={items.length ? 'blue' : 'default'} style={{ margin: 0 }}>
                {items.length}
            </Tag>
        </div>

        {items.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {items.map(renderItem)}
            </div>
        ) : (
            <div style={{
                padding: '10px 12px',
                background: '#fafafa',
                border: '1px solid #f0f0f0',
                borderRadius: 8
            }}>
                <Text type="secondary" style={{ fontSize: 12 }}>{emptyText}</Text>
            </div>
        )}
    </div>
);

const renderHistoryRow = (key, dateValue, children) => (
    <div
        key={key}
        style={{
            padding: '10px 12px',
            border: '1px solid #f0f0f0',
            borderRadius: 8,
            background: '#fff'
        }}
    >
        <Text type="secondary" style={{ display: 'block', fontSize: 11, marginBottom: 6 }}>
            <ClockCircleOutlined style={{ marginRight: 4 }} />
            {formatHistoryDate(dateValue)}{dateValue ? ' PST' : ''}
        </Text>
        {children}
    </div>
);

    // Agent column definition
    const agentColumn = isAdmin ? [{
        title: 'Sales-Agent',
        key: 'agent',
        width: 160,
        sorter: (a, b) => getAgentName(a).localeCompare(getAgentName(b)),
        filters: getUniqueAgents().map(value => ({ text: value, value })),
        filteredValue: filteredInfo.agent || null,
        render: (_, record) => {
            const agentName = getAgentName(record);
            const isUnassigned = agentName === 'Unassigned';
            return (
                <Tooltip title={agentName}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar
                            size={32}
                            icon={<UserOutlined />}
                            style={{
                                backgroundColor: isUnassigned ? '#d9d9d9' : '#722ed1',
                                flexShrink: 0,
                            }}
                        >
                            {!isUnassigned && agentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <Text
                            ellipsis={{ tooltip: true }}
                            style={{
                                fontSize: 13,
                                color: isUnassigned ? '#8c8c8c' : '#1f2937',
                                fontStyle: isUnassigned ? 'italic' : 'normal',
                            }}
                        >
                            {agentName}
                        </Text>
                    </div>
                </Tooltip>
            );
        },
    }] : [];
  
    const columns = [
        ...agentColumn,
    {
    title: 'Payment Service-Agent',
    key: 'serviceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getServiceAgentName(a) || '';
        const nameB = getServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const serviceAgentName = getServiceAgentName(record);
        const isAssigned = !!serviceAgentName;
        
        return (
            <div 
                style={{ cursor: 'pointer' }}
                onClick={() => handleServiceAgentEdit(record)}
            >
                <Tooltip title={isAssigned ? `Click to change service agent` : 'Click to assign service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar
                            size={32}
                            icon={<TeamOutlined />}
                            style={{
                                backgroundColor: isAssigned ? '#52c41a' : '#f0f0f0',
                                flexShrink: 0,
                            }}
                        >
                            {isAssigned && serviceAgentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text
                                        ellipsis={{ tooltip: true }}
                                        style={{
                                            fontSize: 13,
                                            color: '#1f2937',
                                            display: 'block',
                                            fontWeight: 500
                                        }}
                                    >
                                        {serviceAgentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>
                                        Click to edit
                                    </Text>
                                </>
                            ) : (
                                <Text
                                    style={{
                                        fontSize: 13,
                                        color: '#1890ff',
                                        fontStyle: 'italic'
                                    }}
                                >
                                    + Assign Agent
                                </Text>
                            )}
                        </div>
                        <EditOutlined 
                            style={{ 
                                fontSize: 12, 
                                color: '#1890ff',
                                opacity: 0.6
                            }} 
                        />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
        {
            title: "Vehicle",
            key: "vehicleInfo",
            width: 200,
            sorter: (a, b) => (a.vehicleInfo?.make || '').localeCompare(b.vehicleInfo?.make || ''),
            render: (_, record) => (
                <Card size="small" style={{ borderRadius: 10, background: '#fafafa', border: 'none' }} bodyStyle={{ padding: '8px 12px' }}>
                    <div style={{ marginBottom: 4 }}>
                        <Tag color="blue" style={{ marginRight: 6 }}>
                            {record.vehicleInfo?.year || "N/A"}
                        </Tag>
                        {record.queueLead === true && (
                            <Tooltip title="Queued Lead">
                                <TbCircleDottedLetterQ style={{ fontSize: 16, color: "#1677ff" }} />
                            </Tooltip>
                        )}
                    </div>
                    <div style={{ marginBottom: 4 }}>
                        <Text strong>
                            {record.vehicleInfo?.make || "N/A"} / {record.vehicleInfo?.model || ""}
                        </Text>
                    </div>
                    <div>
                        <Tag color="cyan">
                            {record.vehicleInfo?.part || "N/A"}
                        </Tag>
                    </div>
                </Card>
            )
        },
        {
            title: "Customer",
            width: 260,
            key: "fullName",
            render: (_, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Avatar 
                        size={44}
                        icon={<UserOutlined />} 
                        style={{ 
                            background: `linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)`,
                            boxShadow: '0 4px 12px rgba(24,144,255,0.2)',
                            flexShrink: 0
                        }}
                    />
                    <div style={{ flex: 1 }}>
                        <Space align="center" style={{ marginBottom: 4 }}>
                            <Text strong style={{ fontSize: 14 }}>
                                {record.personalInfo?.fullName || 'N/A'}
                            </Text>
                            {record.isExistingCustomer === true && (
                                <Tooltip title="Existing Customer">
                                    <UserSwitchOutlined style={{ color: "#52c41a", fontSize: "14px" }} />
                                </Tooltip>
                            )}
                        </Space>
                        <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
                            <MailOutlined style={{ marginRight: 4 }} />
                            {record.personalInfo?.email || 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
                            <PhoneOutlined style={{ marginRight: 4 }} />
                            {record.personalInfo?.phoneNumber || 'N/A'}
                        </Text>
                    </div>
                </div>
            )
        },
{
    title: "Status & Payment Date",
    key: "statusInfo",
    width: 280,
    render: (_, record) => {
        const stage = record.leadStage;
        const stageConfig = leadStageColors[stage] || {
            color: '#000000',
            background: '#f5f5f5',
        };
        
        const partStatus = record.ShipmentTracking?.partStatus ||
                           record.orderProcessComplete?.partStatus ||
                           'No';
        // The stored default is "Not Available"; show Not Set until someone chooses
        const partConfig = isPartStatusUnset(record)
            ? { color: 'default', icon: null, text: 'Not Set' }
            : getPartStatusConfig(partStatus);
        
        // ✅ FIX: Filter to get ONLY manual entries (those with BOTH oldValue AND newValue)
        // AND sort by date to get the latest manual entry
        const manualPartStatusHistory = record.ShipmentTrackingHistory
            ?.filter(history => 
                history.field === 'ShipmentTracking.partStatus' &&
                history.oldValue !== undefined &&  // Has old value
                history.newValue !== undefined &&   // Has new value
                history.oldValue !== history.newValue // Not a no-change entry
            )
            .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt));
        
        // Get the latest MANUAL entry (not auto-generated)
       const lastManualChange = getLastManualPartStatusChange(record);
        const changedDate = lastManualChange?.changedAt ? dayjs(lastManualChange.changedAt).tz('America/Los_Angeles') : null;

        // Get pending payment date
        const pendingPaymentAt = getStageDate(record, 'Sales Made');
        const pendingDate = pendingPaymentAt ? dayjs(pendingPaymentAt).tz('America/Los_Angeles') : null;
        
        return (
            <div>
                {/* Part Status with Manual Date Entry */}
                <div style={{ marginBottom: 12 }}>
                    <div>
                        <Space size={2} style={{ width: '100%', justifyContent: 'space-between', marginBottom: 4 }}>
                            <Tag 
                                icon={partConfig.icon}
                                color={partConfig.color}
                                style={{ 
                                    padding: '4px 12px', 
                                    borderRadius: 16,
                                    fontSize: 12,
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    margin: 0,
                                    flex: 1,
                                    textAlign: 'center'
                                }}
                                onClick={() => handlePartStatusEditStart(record)}
                            >
                                {partConfig.text}
                            </Tag>
                            <Tooltip title="Edit Part Status with Date">
                                <EditOutlined
                                    style={{ 
                                        color: '#1890ff', 
                                        cursor: 'pointer',
                                        fontSize: 12
                                    }}
                                    onClick={() => handlePartStatusEditStart(record)}
                                />
                            </Tooltip>
                        </Space>
                        
                      
                        {changedDate && (
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 4,
                                marginTop: 2,
                                fontSize: 10,
                                color: '#8c8c8c'
                            }}>
                                <ClockCircleOutlined style={{ fontSize: 10 }} />
                                <Text type="secondary" style={{ fontSize: 10 }}>
                                    Updated on: {changedDate.format('MM/DD/YY · hh:mm A')}
                                </Text>
                            </div>
                        )}
                    </div>
                </div>

                {/* Sales Made Date - Separator */}
                <div style={{ 
                    borderTop: '1px dashed #e8e8e8', 
                    margin: '8px 0',
                    paddingTop: 8
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{
                            width: 24, height: 24, borderRadius: 6,
                            background: '#FFF2E8',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0,
                        }}>
                            <DollarOutlined style={{ fontSize: 11, color: '#ad4e00' }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Text style={{ fontSize: 12, fontWeight: 500, color: '#ad4e00' }}>
                                    Sales Made:
                                </Text>
                                <Text style={{ fontSize: 12, fontWeight: 500, color: '#ad4e00' }}>
                                    {pendingDate ? pendingDate.format('MM/DD/YYYY') : 'Not Set'}
                                </Text>
                            </div>
                            {pendingDate && (
                                <Text type="secondary" style={{ fontSize: 10 }}>
                                    {pendingDate.fromNow()} · PST
                                </Text>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    },
},
        {
            title: "Payment",
            key: "paymentDetails",
            width: 250,
            sorter: (a, b) => (a.totalAmount || 0) - (b.totalAmount || 0),
            render: (_, record) => {
                const totalAmount = record.totalAmount || 0;
                const paidAmount = getCompletedAdvancePaidAmount(record);
                const balance = getOutstandingBalance(record);
                
                // Get latest payment by date
                const advancePayments = record.advancePayments || [];
                const latestPayment = advancePayments.length > 0 
                    ? advancePayments.sort((a, b) => new Date(b.date) - new Date(a.date))[0]
                    : null;
                const latestPaymentDate = latestPayment?.date ? dayjs(latestPayment.date).tz('America/Los_Angeles') : null;
                
                return (
                    <Card size="small" style={{ borderRadius: 10, background: '#fafafa', border: 'none' }} bodyStyle={{ padding: '8px 12px' }}>
                        {/* Total Amount - Now opens modal */}
                        <div style={{ marginBottom: 6 }}>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'minmax(0, 1fr) 28px auto',
                                alignItems: 'center',
                                columnGap: 8
                            }}>
                                <Space size={4} style={{ minWidth: 0, whiteSpace: 'nowrap' }}>
                                    <DollarOutlined style={{ color: '#1890ff', fontSize: 11 }} />
                                    <Text style={{ fontSize: 11 }}>Total:</Text>
                                    <Text strong style={{ fontSize: 12 }}>{formatCurrency(totalAmount)}</Text>
                                </Space>
                                <Tooltip title="Advance Payment History">
                                    <Button
                                        icon={<HistoryOutlined />}
                                        onClick={() => {
                                            setSelectedLeadForHistory(record);
                                            setHistoryModalVisible(true);
                                        }}
                                        size="small"
                                        shape="circle"
                                        style={{ width: 26, minWidth: 26, height: 26 }}
                                    />
                                </Tooltip>
                                <Button
                                    size="small"
                                    type="default"
                                    style={{
                                        fontSize: 10,
                                        padding: '2px 8px',
                                        borderRadius: 6,
                                        borderColor: '#1890ff',
                                        color: '#1890ff',
                                        height: 26
                                    }}
                                    onClick={() => handleRequoteOpen(record)}
                                >
                                    Re-Quoted
                                </Button>
                            </div>
                        </div>
                        
                        {/* Paid Amount - Read Only */}
                        <div style={{ marginBottom: 6 }}>
                            <Space size={4}>
                                <CreditCardOutlined style={{ color: '#52c41a', fontSize: 11 }} />
                                <Text style={{ fontSize: 11 }}>Paid:</Text>
                                <Text strong style={{ fontSize: 12, color: '#52c41a' }}>{formatCurrency(paidAmount)}</Text>
                            </Space>
                        </div>
                        
                        {/* Balance - Read Only */}
                        <div style={{ marginBottom: latestPaymentDate ? 6 : 0 }}>
                            <Space size={4}>
                                <WalletOutlined style={{ color: balance > 0 ? '#fa8c16' : '#52c41a', fontSize: 11 }} />
                                <Text style={{ fontSize: 11 }}>Balance:</Text>
                                <Text strong style={{ 
                                    fontSize: 12, 
                                    color: balance > 0 ? '#fa8c16' : '#52c41a'
                                }}>
                                    {formatCurrency(balance)}
                                </Text>
                            </Space>
                        </div>
                        
                        {/* Latest payment with full date and time */}
                        {latestPaymentDate && (
                            <div style={{ 
                                marginTop: 6,
                                paddingTop: 6,
                                borderTop: '1px dashed #e8e8e8'
                            }}>
                                <Tooltip title={`Amount: ${formatCurrency(latestPayment.amount)} • Method: ${latestPayment.paymentMethod} • Status: ${latestPayment.status}`}>
                                    <Space size={4} direction="vertical" style={{ width: '100%', gap: 2 }}>
                                        <Space size={4}>
                                            <ClockCircleOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                                            <Text type="secondary" style={{ fontSize: 10 }}>
                                                Last payment: {latestPaymentDate.format('MM/DD/YYYY · hh:mm A')}
                                            </Text>
                                        </Space>
                                    </Space>
                                </Tooltip>
                            </div>
                        )}
                    </Card>
                );
            }
        },
        {
    title: 'Specification',
    key: 'specification',
    width: 280,
    render: (_, record) => {
        const specification = record.vehicleInfo?.specification || '';
        const hasSpecification = specification && specification.trim().length > 0;
        
        return (
            <div 
                style={{ 
                    cursor: 'pointer',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={() => handleSpecificationEdit(record)}
            >
                {/* Display Specification Content */}
                {hasSpecification ? (
                    <div 
                        style={{
                            background: '#f0f8ff',
                            padding: '12px',
                            borderRadius: '8px',
                            border: '1px solid #91d5ff',
                            transition: 'all 0.3s ease',
                            wordBreak: 'break-word',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            minHeight: '80px',
                            position: 'relative'
                        }}
                    >
                        {/* Edit Icon - Top Right */}
                        <EditOutlined 
                            style={{ 
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: 12,
                                color: '#1890ff',
                                opacity: 0.7
                            }} 
                        />
                        
                        {/* Specification Text */}
                        <Text style={{ 
                            fontSize: '12px',
                            display: 'block',
                            lineHeight: 1.5,
                            paddingRight: '20px'
                        }}>
                            {specification}
                        </Text>
                    </div>
                ) : (
                    <div 
                        style={{ 
                            textAlign: 'center', 
                            padding: '20px',
                            background: '#fafafa',
                            borderRadius: '8px',
                            border: '1px dashed #d9d9d9',
                            transition: 'all 0.3s ease',
                            position: 'relative'
                        }}
                    >
                        <EditOutlined 
                            style={{ 
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: 12,
                                color: '#1890ff',
                                opacity: 0.7
                            }} 
                        />
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <FileTextOutlined style={{ marginRight: '8px', fontSize: '14px' }} />
                            No specification added
                        </Text>
                        <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}>
                            Click to add
                        </Text>
                    </div>
                )}
                
                {/* Last Updated Info - if specification exists and has history */}
                {hasSpecification && record.vehicleInfo?.specificationUpdatedAt && (
                    <div style={{ 
                        marginTop: 6,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        justifyContent: 'flex-end'
                    }}>
                        <Tooltip title={`Last updated: ${dayjs(record.vehicleInfo.specificationUpdatedAt).format('MMM DD, YYYY hh:mm A')}`}>
                            <Space size={4}>
                                <ClockCircleOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                                <Text type="secondary" style={{ fontSize: 10 }}>
                                    Updated: {dayjs(record.vehicleInfo.specificationUpdatedAt).fromNow()}
                                </Text>
                            </Space>
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    },
},
{
    title: 'Comment',
    key: 'advancePaymentPageComment',
    width: 280,
    render: (_, record) => {
        const comments = record.advancePaymentPageComment || [];
        const latestComment = comments.length > 0 ? comments[comments.length - 1] : null;
        
        return (
            <div>
             

                {/* Display Latest Comment */}
                {latestComment ? (
                    <div 
                        style={{
                            background: '#fafafa',
                            padding: '8px 10px',
                            borderRadius: '8px',
                            border: '1px solid #f0f0f0',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            wordBreak: 'break-word',      // Add this
                            wordWrap: 'break-word',       // Add this
                            overflowWrap: 'break-word',   // Add this
                            whiteSpace: 'normal'          // Add this
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeadForComment(record);
                            setCommentsModalVisible(true);
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                {formatCommentDate(latestComment.changedAt)}
                            </Text>
                            {comments.length > 1 && (
                                <Tag 
                                    color="blue" 
                                    style={{ 
                                        fontSize: '10px', 
                                        padding: '0 4px', 
                                        margin: 0,
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedLeadForComment(record);
                                        setCommentsModalVisible(true);
                                    }}
                                >
                                    +{comments.length - 1} more
                                </Tag>
                            )}
                        </div>
                        <Text style={{ 
                            fontSize: '12px', 
                            display: 'block', 
                            wordBreak: 'break-word',    // Add this
                            whiteSpace: 'pre-wrap'       // Add this for preserving whitespace and wrapping
                        }}>
                            {latestComment.comment.length > 80 
                                ? `${latestComment.comment.substring(0, 80)}...` 
                                : latestComment.comment}
                        </Text>
                    </div>
                ) : (
                    <div 
                        style={{ 
                            textAlign: 'center', 
                            padding: '12px',
                            background: '#fafafa',
                            borderRadius: '8px',
                            border: '1px solid #f0f0f0',
                            cursor: 'pointer'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeadForComment(record);
                            setCommentsModalVisible(true);
                        }}
                    >
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <CommentOutlined style={{ marginRight: '4px', fontSize: '14px' }} />
                            No comments yet
                        </Text>
                    </div>
                )}
                   <Button
                    type="primary"
                    size="small"
                    icon={<CommentOutlined />}
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedLeadForComment(record);
                        setNewComment('');
                        setCommentsModalVisible(true);
                    }}
                    style={{ 
                        marginBottom: '12px',
                        width: '100%',
                        fontSize: '12px'
                    }}
                >
                    Add Comment
                </Button>
            </div>
        );
    },
},
        {
            title: "Date Info",
            key: "dateInfo",
            width: 210,
            sorter: (a, b) => {
                // Sort by Sales Made date
                const getPendingDate = (lead) => {
                    const pendingStage = lead.leadStageHistory?.find(
                        stage => stage.stage === 'Sales Made'
                    );
                    return pendingStage?.changedAt || lead.createdAt;
                };
                const aDate = new Date(getPendingDate(a));
                const bDate = new Date(getPendingDate(b));
                return bDate - aDate; // Descending (newest first)
            },
            render: (_, record) => {
                const createdAt = record.createdAt;
                const updatedAt = record.updatedAt;

                const toPST = (date) => date ? dayjs(date).tz('America/Los_Angeles') : null;
                const created = toPST(createdAt);
                const updated = toPST(updatedAt);

                return (
                    <Tooltip
                        title={
                            <>
                                <div><strong>Created:</strong> {created ? created.format('MM/DD/YYYY hh:mm A') + ' PST' : 'N/A'}</div>
                                <div><strong>Updated:</strong> {updated ? updated.format('MM/DD/YYYY hh:mm A') + ' PST' : 'N/A'}</div>
                            </>
                        }
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {/* Created Row - Read Only */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{
                                    width: 28, height: 28, borderRadius: 8,
                                    background: '#F1EFE8',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    flexShrink: 0,
                                }}>
                                    <ClockCircleOutlined style={{ fontSize: 13, color: '#888780' }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2 }}>
                                        {created ? created.format('MM/DD/YY · hh:mm A') : 'N/A'}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                                        Created · {created ? created.fromNow() : '—'} · PST
                                    </Text>
                                </div>
                            </div>

                            {/* Updated Row - Read Only */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{
                                    width: 28, height: 28, borderRadius: 8,
                                    background: '#E6F1FB',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    flexShrink: 0,
                                }}>
                                    <SyncOutlined style={{ fontSize: 13, color: '#185FA5' }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2, color: '#185FA5' }}>
                                        {updated ? updated.format('MM/DD/YY · hh:mm A') : 'N/A'}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                                        Updated · {updated ? updated.fromNow() : '—'} · PST
                                    </Text>
                                </div>
                            </div>
                        </div>
                    </Tooltip>
                );
            },
        },
        {
            title: '',
            key: 'actions',
            width: 80,
            fixed: 'right',
            render: (_, record) => (
                <Space>
                    <Tooltip title={record.personalInfo?.phoneNumber ? "Call Customer" : "No phone number"}>
                        <Button
                            icon={<PhoneOutlined />}
                            href={`tel:${record.personalInfo?.phoneNumber}`}
                            disabled={!record.personalInfo?.phoneNumber}
                            size="small"
                            shape="circle"
                            type="primary"
                            ghost
                            onClick={() => {
                                setCalledLeads(prev => new Set(prev).add(record._id));
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="View Details">
                        <Button
                            icon={<EyeOutlined />}
                            onClick={() => navigate(`/lead-details/${record._id}`)}
                            size="small"
                            shape="circle"
                            type="primary"
                            style={{ 
                                background: `linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)`,
                                border: 'none'
                            }}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ 
            padding: 24, 
            minHeight: '100vh', 
            background: `linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)`
        }}>
            {/* Modern Header with Stats */}
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Card 
                    style={{ 
                        marginBottom: 24, 
                        borderRadius: 24,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '32px' }}
                >
                    <Row gutter={[24, 24]} align="middle">
                        <Col xs={24} md={12}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                <Avatar 
                                    size={72} 
                                    style={{ 
                                        background: 'rgba(255,255,255,0.2)',
                                        backdropFilter: 'blur(10px)',
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                                        color:"black"
                                    }}
                                    icon={<ShoppingOutlined style={{ fontSize: 36 }} />}
                                />
                                <div>
                                    <Title level={2} style={{ margin: 0, fontWeight: 700 }}>
                                        Advance Management
                                    </Title>
                                    <Text style={{ fontSize: 14 }}>
                                        Track and manage payment collections
                                    </Text>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </motion.div>

            {/* Filter Section */}
            <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
            >
                <Card 
                    bordered={false}
                    style={{ 
                        borderRadius: 20,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                        marginBottom: 24,
                        border: '1px solid #f0f0f0'
                    }}
                    bodyStyle={{ padding: '20px 24px' }}
                >
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={24} md={8}>
                            <Space.Compact block>
                                <SearchFieldsSelect value={searchFields} onChange={setSearchFields} />
                                <Input
                                    placeholder={getSearchFieldsPlaceholder(searchFields)}
                                    prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    allowClear
                                    size="large"
                                />
                            </Space.Compact>
                        </Col>
                        {isAdmin && (
                            <Col xs={24} md={4}>
                                <Select
                                    placeholder="Filter by Agent"
                                    value={selectedAgentId}
                                    onChange={setSelectedAgentId}
                                    style={{ width: '100%', borderRadius: 12 }}
                                    size="large"
                                    allowClear
                                    suffixIcon={<TeamOutlined />}
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    {agents.map(agent => (
                                        <Option key={agent._id} value={agent._id}>
                                            <Space>
                                                <Avatar size="small" icon={<UserOutlined />} />
                                                <span>{agent.firstName} {agent.lastName}</span>
                                            </Space>
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                        )}
                        <Col xs={24} md={4}>
                            <Select 
                                value={quickFilter} 
                                onChange={handleQuickFilter}
                                style={{ width: '100%', borderRadius: 12 }}
                                size="large"
                            >
                                <Option value="today">Today</Option>
                                <Option value="yesterday">Yesterday</Option>
                                <Option value="thisWeek">This Week</Option>
                                <Option value="lastWeek">Last Week</Option>
                                <Option value="currentMonth">Current Month</Option>
                                <Option value="lastMonth">Last Month</Option>
                                <Option value="thisYear">This Year</Option>
                            </Select>
                        </Col>
                        <Col xs={24} md={isAdmin ? 7 : 8}>
<RangePicker
    value={dateRange}
    onChange={(dates) => {
        // Handle cancellation (when dates is null)
        if (!dates || !dates[0] || !dates[1]) {
            setDateRange([dayjs().startOf('month'), dayjs().endOf('month')]);
            setQuickFilter('currentMonth');
        } else {
            setDateRange(dates);
        }
    }}
    disabledDate={(current) => current && current > dayjs().endOf('day')}
    style={{ width: '100%', borderRadius: 12 }}
    size="large"
    format="MM/DD/YYYY"
    placeholder={['Start Date', 'End Date']}
/>
                        </Col>
                        <Col xs={24} md={isAdmin ? 4 : 6}>
                            <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                                <Tooltip title="Refresh">
                                    <Button 
                                        icon={<ReloadOutlined />} 
                                        onClick={fetchLeads}
                                        loading={loading}
                                        size="large"
                                        style={{ borderRadius: 12 }}
                                    />
                                </Tooltip>
                                <Tooltip title="Clear Filters">
                                    <Button 
                                        icon={<ClearOutlined />} 
                                        onClick={clearFilters}
                                        size="large"
                                        style={{ borderRadius: 12 }}
                                    />
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>

                  {/* Date Range Info */}
<div style={{ 
    marginTop: 16,
    backgroundColor: '#f0f5ff', 
    padding: '8px 12px', 
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8
}}>
    <CalendarOutlined style={{ color: '#1890ff' }} />
    <Text type="secondary">
        Showing leads from: <Text strong>
            {dateRange && dateRange[0] ? dateRange[0].format('MM/DD/YYYY') : 'N/A'}
        </Text> to <Text strong>
            {dateRange && dateRange[1] ? dateRange[1].format('MM/DD/YYYY') : 'N/A'}
        </Text>
    </Text>
    <Badge 
        count={totalRecords} 
        showZero 
        color="#52c41a" 
        style={{ marginLeft: 'auto' }}
    />
</div>
                </Card>
            </motion.div>

            {/* Main Table */}
            <Card 
                bordered={false}
                style={{ 
                    borderRadius: 20,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    overflow: 'hidden'
                }}
                bodyStyle={{ padding: 0 }}
            >
                <Table
                    columns={columns}
                    dataSource={leads}
                    rowKey={(record) => record._id || record.key}
                    loading={loading}
                   pagination={{
    current: currentPage,
    pageSize: pageSize,
    total: totalRecords,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
    defaultPageSize: 10,
    position: ['topRight'],
    onChange: handlePageChange,
    onShowSizeChange: handlePageSizeChange,
    showTotal: (total, range) => (
        <Space>
            <AccountBookOutlined />
            <Text strong>{total}</Text> total leads | Showing <Text strong>{range[0]}-{range[1]}</Text>
        </Space>
    ),
    size: 'default',
    style: { padding: '16px 24px' }
}}
                    onChange={handleTableChange}
                    scroll={{
                        x: isAdmin ? 1600 : 1400,
                        y: 'calc(100vh - 550px)'
                    }}
                    size="middle"
                    bordered={false}
                    rowClassName={(record) => {
                        const balance = getOutstandingBalance(record);
                        return balance > 0 ? 'payment-pending-row' : 'payment-completed-row';
                    }}
                    className="payment-table"
                />
            </Card>

            <Modal
                title={
                    <Space>
                        <HistoryOutlined />
                        <span>Advance Payment History</span>
                    </Space>
                }
                open={historyModalVisible}
                onCancel={() => {
                    setHistoryModalVisible(false);
                    setSelectedLeadForHistory(null);
                }}
                footer={[
                    <Button
                        key="close"
                        onClick={() => {
                            setHistoryModalVisible(false);
                            setSelectedLeadForHistory(null);
                        }}
                    >
                        Close
                    </Button>
                ]}
                width={760}
            >
                {selectedLeadForHistory && (
                    <div>
                        <div style={{
                            padding: '10px 12px',
                            background: '#fafafa',
                            border: '1px solid #f0f0f0',
                            borderRadius: 8,
                            marginBottom: 16
                        }}>
                            <Text strong style={{ display: 'block' }}>
                                {selectedLeadForHistory.personalInfo?.fullName || 'N/A'}
                            </Text>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {selectedLeadForHistory.vehicleInfo?.year || ''} {selectedLeadForHistory.vehicleInfo?.make || ''} {selectedLeadForHistory.vehicleInfo?.model || ''} - {selectedLeadForHistory.vehicleInfo?.part || 'N/A'}
                            </Text>
                        </div>

                        <div style={{ maxHeight: '65vh', overflowY: 'auto', paddingRight: 4 }}>
                            {renderHistorySection(
                                'Advance Payments',
                                sortHistoryNewestFirst(selectedLeadForHistory.advancePayments, payment => payment.date),
                                (payment, index) => renderHistoryRow(
                                    payment._id || payment.id || `payment-${index}`,
                                    payment.date,
                                    (() => {
                                        const addedBy = getHistoryActorName(payment, ['createdBy']);
                                        const updatedBy = getHistoryActorName(payment, ['lastUpdatedBy']);
                                        const showUpdatedBy = updatedBy && updatedBy !== addedBy;

                                        return (
                                            <>
                                        <Space size={[6, 6]} wrap>
                                            <Text strong style={{ color: '#52c41a' }}>
                                                {formatCurrency(payment.amount)}
                                            </Text>
                                            <Tag color="blue">{sanitizeHistoryText(payment.paymentMethod, 'Method N/A')}</Tag>
                                            <Tag color={getPaymentStatusColor(payment.status)}>
                                                {sanitizeHistoryText(payment.status, 'Status N/A')}
                                            </Tag>
                                        </Space>
                                        {payment.transactionId && (
                                            <Text type="secondary" style={{ display: 'block', fontSize: 12, marginTop: 6 }}>
                                                Transaction ID: <Text code>{String(payment.transactionId)}</Text>
                                            </Text>
                                        )}
                                        {payment.description && (
                                            <Text style={{ display: 'block', fontSize: 12, marginTop: 6 }}>
                                                {sanitizeHistoryText(payment.description)}
                                            </Text>
                                        )}
                                                {renderActorLine('Added By', addedBy)}
                                                {showUpdatedBy && renderActorLine('Updated By', updatedBy)}
                                            </>
                                        );
                                    })()
                                ),
                                'No advance payments found'
                            )}

                            {renderHistorySection(
                                'Advance Payment Comments',
                                sortHistoryNewestFirst(selectedLeadForHistory.advancePaymentPageComment, comment => comment.changedAt),
                                (comment, index) => renderHistoryRow(
                                    `advance-comment-${index}`,
                                    comment.changedAt,
                                    <>
                                        <Text style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>
                                            {sanitizeHistoryText(comment.comment, 'No comment')}
                                        </Text>
                                        {renderActorLine('Added By', getHistoryActorName(comment, ['changedBy']))}
                                    </>
                                ),
                                'No advance payment comments found'
                            )}

                            {renderHistorySection(
                                'Re-Quoted Amount History',
                                getRequotedHistoryEntries(selectedLeadForHistory),
                                (quote, index) => renderHistoryRow(
                                    quote._id || `quote-${index}`,
                                    quote.addedAt,
                                    <>
                                        <Text strong>
                                            {quote.previousPrice !== undefined
                                                ? `${formatCurrency(quote.previousPrice)} -> ${formatCurrency(quote.price)}`
                                                : formatCurrency(quote.price)}
                                        </Text>
                                        {renderActorLine('Changed By', getHistoryActorName(quote, ['changedBy']))}
                                    </>
                                ),
                                'No re-quoted amount history found'
                            )}

                            {renderHistorySection(
                                'Part Status Changes',
                                getPartStatusHistoryEntries(selectedLeadForHistory),
                                (entry, index) => renderHistoryRow(
                                    entry._id || `part-status-${index}`,
                                    entry.changedAt,
                                    <>
                                        <Space size={[6, 6]} wrap>
                                            <Tag>{sanitizeHistoryText(entry.oldValue, 'N/A')}</Tag>
                                            <Text type="secondary">to</Text>
                                            <Tag color="blue">{sanitizeHistoryText(entry.newValue, 'N/A')}</Tag>
                                        </Space>
                                        {renderActorLine('Changed By', getHistoryActorName(entry, ['changedBy']))}
                                    </>
                                ),
                                'No part status changes found'
                            )}

                            {renderHistorySection(
                                'Service-Agent Assignment Audit',
                                getServiceAgentAuditEntries(selectedLeadForHistory),
                                (entry, index) => renderHistoryRow(
                                    entry._id || `service-agent-${index}`,
                                    entry.timestamp,
                                    (() => {
                                        const changedBy = getHistoryActorName(entry, ['byUser', 'by']);

                                        return (
                                            <>
                                        <Tag color="purple">
                                            {sanitizeHistoryText(entry.action, 'Service Agent').replace(/_/g, ' ')}
                                        </Tag>
                                        <Text style={{ display: 'block', fontSize: 12, marginTop: 6 }}>
                                            {sanitizeHistoryText(entry.details, 'No details')}
                                        </Text>
                                                {renderActorLine('Changed By', changedBy)}
                                            </>
                                        );
                                    })()
                                ),
                                'No service-agent assignment audit found'
                            )}

                            {renderHistorySection(
                                'Pending Payment / Sales Made Stage History',
                                getPaymentStageHistoryEntries(selectedLeadForHistory),
                                (entry, index) => renderHistoryRow(
                                    entry._id || `stage-${index}`,
                                    entry.changedAt,
                                    <>
                                        <Tag color={entry.stage === 'Sales Made' ? 'green' : 'orange'}>
                                            {sanitizeHistoryText(entry.stage)}
                                        </Tag>
                                        {entry.comment && (
                                            <Text style={{ display: 'block', fontSize: 12, marginTop: 6 }}>
                                                {sanitizeHistoryText(entry.comment)}
                                            </Text>
                                        )}
                                        {renderActorLine('Changed By', getHistoryActorName(entry, ['changedBy']))}
                                    </>
                                ),
                                'No Pending Payment or Sales Made stage history found'
                            )}
                        </div>
                    </div>
                )}
            </Modal>

            {/* Re-Quoted Modal */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{
                            width: 40,
                            height: 40,
                            borderRadius: 12,
                            background: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <DollarOutlined style={{ fontSize: 20, color: 'white' }} />
                        </div>
                        <div>
                            <Title level={4} style={{ margin: 0 }}>Re-Quoted Amount</Title>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                Update total amount for this lead
                            </Text>
                        </div>
                    </div>
                }
                open={isRequoteModalVisible}
                onCancel={handleRequoteCancel}
                footer={null}
                width={480}
                centered
                modalRender={(modal) => (
                    <div style={{ borderRadius: 20, overflow: 'hidden' }}>
                        {modal}
                    </div>
                )}
            >
                <Form
                    form={requoteForm}
                    layout="vertical"
                    onFinish={handleRequoteSave}
                    style={{ marginTop: 16 }}
                >
                    {selectedLeadForRequote && (
                        <>
                            {/* Customer Info Card */}
                            <Card 
                                size="small" 
                                style={{ 
                                    marginBottom: 20,
                                    background: '#f5f5f5',
                                    borderRadius: 12,
                                    border: 'none'
                                }}
                                bodyStyle={{ padding: '12px 16px' }}
                            >
                                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                                    <Text strong>
                                        {selectedLeadForRequote.personalInfo?.fullName || 'N/A'}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        {selectedLeadForRequote.vehicleInfo?.make} {selectedLeadForRequote.vehicleInfo?.model} - {selectedLeadForRequote.vehicleInfo?.part}
                                    </Text>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: 8,
                                        marginTop: 4,
                                        paddingTop: 4,
                                        borderTop: '1px solid #e8e8e8'
                                    }}>
                                        <Text type="secondary" style={{ fontSize: 11 }}>
                                            Current Total: 
                                        </Text>
                                        <Text strong style={{ fontSize: 12, color: '#1890ff' }}>
                                            {formatCurrency(selectedLeadForRequote.totalAmount || 0)}
                                        </Text>
                                    </div>
                                </Space>
                            </Card>

                            {/* Total Amount Input */}
                            <Form.Item
                                name="totalAmount"
                                label="New Total Amount"
                                rules={[
                                    { required: true, message: 'Please enter total amount' },
                                    { 
                                        validator: (_, value) => {
                                            if (value && value <= 0) {
                                                return Promise.reject('Amount must be greater than 0');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    size="large"
                                    min={0}
                                    step={0.01}
                                    prefix="$"
                                    placeholder="Enter new total amount"
                                    formatter={(value) => 
                                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                    parser={(value) => 
                                        value.replace(/\$\s?|(,*)/g, '')
                                    }
                                    autoFocus
                                />
                            </Form.Item>

                          

                            {/* Modal Actions */}
                            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 8 }}>
                                <Button onClick={handleRequoteCancel} size="large">
                                    Cancel
                                </Button>
                                <Button 
                                    type="primary" 
                                    htmlType="submit" 
                                    loading={savingRequote}
                                    size="large"
                                    icon={<CheckOutlined />}
                                >
                                    Update Total
                                </Button>
                            </div>
                        </>
                    )}
                </Form>
            </Modal>
{/* Part Status Update Modal with Manual Date */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <EditOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Update Part Status</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Manually set status and date
                </Text>
            </div>
        </div>
    }
    open={partStatusModalVisible}
    onCancel={() => {
        setPartStatusModalVisible(false);
        setSelectedLeadForPartStatus(null);
        setTempPartStatus('');
        setTempPartStatusDate(null);
    }}
    footer={null}
    width={480}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForPartStatus && (
            <>
                {/* Customer Info */}
                <Card 
                    size="small" 
                    style={{ 
                        marginBottom: 20,
                        background: '#f5f5f5',
                        borderRadius: 12,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                        <Text strong>
                            {selectedLeadForPartStatus.personalInfo?.fullName || 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {selectedLeadForPartStatus.vehicleInfo?.make} {selectedLeadForPartStatus.vehicleInfo?.model} - {selectedLeadForPartStatus.vehicleInfo?.part}
                        </Text>
                    </Space>
                </Card>

                {/* Part Status Selection */}
                <div style={{ marginBottom: 20 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Part Status:
                    </Text>
                    <Select
                        value={tempPartStatus}
                        onChange={setTempPartStatus}
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="Select part status"
                    >
                        {[
                            'Available',
                            'Not Available',
                            'Not Good',
                            'Wrong Part',
                            'Customer Canceled Order'
                        ].map(option => (
                            <Option key={option} value={option}>{option}</Option>
                        ))}
                    </Select>
                </div>

                {/* Manual Date Picker */}
                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Status Change Date & Time:
                    </Text>
                    <DatePicker
                        value={tempPartStatusDate}
                        onChange={setTempPartStatusDate}
                       
                        format="MM/DD/YYYY"
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="Select date"
                    />
                    <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                        You can manually set any date and time (PST timezone will be applied)
                    </Text>
                </div>

                {/* Modal Actions */}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                    <Button 
                        onClick={() => {
                            setPartStatusModalVisible(false);
                            setSelectedLeadForPartStatus(null);
                            setTempPartStatus('');
                            setTempPartStatusDate(null);
                        }} 
                        size="large"
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="primary" 
                        onClick={handlePartStatusManualUpdate}
                        loading={savingPartStatusManual}
                        size="large"
                        icon={<CheckOutlined />}
                        disabled={!tempPartStatus || !tempPartStatusDate}
                    >
                        Update Status
                    </Button>
                </div>
            </>
        )}
    </div>
</Modal>
            <style>{`
                .payment-table .ant-table-row:hover {
                    background: linear-gradient(90deg, #f0f7ff 0%, #ffffff 100%) !important;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                .payment-pending-row {
                    background-color: #fff2e8;
                }
                .payment-completed-row {
                    background-color: #f6ffed;
                }
                .ant-table-tbody > tr > td {
                    border-bottom: 1px solid #f0f0f0 !important;
                }
                .ant-table-thead > tr > th {
                    background: #fafafa !important;
                    font-weight: 600 !important;
                    font-size: 13px !important;
                    color: #1f2937 !important;
                    border-bottom: 2px solid #f0f0f0 !important;
                }
                .ant-modal-content {
                    border-radius: 20px !important;
                }
                .ant-modal-header {
                    border-radius: 20px 20px 0 0 !important;
                    border-bottom: none !important;
                    padding: 24px 24px 0 24px !important;
                }
                .ant-modal-body {
                    padding: 24px !important;
                }
            `}</style>

            <Modal
   
    open={commentsModalVisible}
    onCancel={() => {
        setCommentsModalVisible(false);
        setSelectedLeadForComment(null);
        setNewComment('');
    }}
    footer={[
        <Button key="cancel" onClick={() => {
            setCommentsModalVisible(false);
            setSelectedLeadForComment(null);
            setNewComment('');
        }}>
            Cancel
        </Button>,
        <Button 
            key="submit" 
            type="primary" 
            onClick={handleAddComment}
            loading={addingComment}
            disabled={!newComment.trim()}
        >
            Add Comment
        </Button>
    ]}
    width={500}
>
    <div style={{ padding: '16px 0' }}>
      

        <div>
            <Text strong>Comment:</Text>
            <Input.TextArea
                placeholder="Enter your comment here..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                rows={4}
                maxLength={1000}
                showCount
                style={{ marginTop: '8px' }}
                autoFocus
            />
        </div>

        {/* Show existing comments if any */}
        {selectedLeadForComment?.advancePaymentPageComment?.length > 0 && (
            <div style={{ marginTop: '20px' }}>
                <Divider />
                <Text strong>Previous Comments ({selectedLeadForComment.advancePaymentPageComment.length})</Text>
                <div style={{ 
                    maxHeight: '200px', 
                    overflowY: 'auto', 
                    marginTop: '8px',
                    padding: '8px',
                    background: '#f5f5f5',
                    borderRadius: '8px'
                }}>
                    {[...selectedLeadForComment.advancePaymentPageComment]
                        .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))
                        .map((comment, idx) => (
                            <div key={idx} style={{ 
                                marginBottom: '12px', 
                                padding: '8px',
                                background: 'white',
                                borderRadius: '6px',
                                border: '1px solid #e8e8e8'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                    <Text type="secondary" style={{ fontSize: '11px' }}>
                                        <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                        {formatCommentDate(comment.changedAt)}
                                    </Text>
                                </div>
                                <Text style={{ fontSize: '13px' }}>{comment.comment}</Text>
                            </div>
                        ))}
                </div>
            </div>
        )}
    </div>
</Modal>
{/* Service Agent Assignment Modal */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <TeamOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Assign Service Agent</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Select service agent for this lead
                </Text>
            </div>
        </div>
    }
    open={serviceAgentModalVisible}
    onCancel={() => {
        setServiceAgentModalVisible(false);
        setSelectedLeadForServiceAgent(null);
        setSelectedServiceAgentForLead(null);
    }}
    footer={null}
    width={500}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForServiceAgent && (
            <>
                {/* Customer Info Card */}
                <Card 
                    size="small" 
                    style={{ 
                        marginBottom: 20,
                        background: '#f5f5f5',
                        borderRadius: 12,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                        <Text strong>
                            {selectedLeadForServiceAgent.personalInfo?.fullName || 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {selectedLeadForServiceAgent.vehicleInfo?.make} {selectedLeadForServiceAgent.vehicleInfo?.model} - {selectedLeadForServiceAgent.vehicleInfo?.part}
                        </Text>
                        {selectedLeadForServiceAgent.orderServiceHandledBy && (
                            <div style={{ 
                                marginTop: 8,
                                paddingTop: 8,
                                borderTop: '1px solid #e8e8e8'
                            }}>
                                <Text type="secondary" style={{ fontSize: 11 }}>
                                    Currently assigned: 
                                </Text>
                                <Text strong style={{ fontSize: 12, color: '#52c41a', marginLeft: 8 }}>
                                    {getServiceAgentName(selectedLeadForServiceAgent)}
                                </Text>
                            </div>
                        )}
                    </Space>
                </Card>

                {/* Service Agent Selection */}
                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Select Payemnt/order Service Agent:
                    </Text>
                    <Select
                        value={selectedServiceAgentForLead}
                        onChange={setSelectedServiceAgentForLead}
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="Choose an agent"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        loading={loadingServiceAgents}
                    >
                        {Object.entries(serviceAgentsMap).map(([agentId, agentInfo]) => (
                            <Option key={agentId} value={agentId}>
                                <Space direction="vertical" size={0}>
                                    <Text strong>{agentInfo.name}</Text>
                                
                                </Space>
                            </Option>
                        ))}
                    </Select>
                    <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                        {selectedServiceAgentForLead ? 'Agent will be assigned to this lead' : 'Clear to unassign the current agent'}
                    </Text>
                </div>

                {/* Modal Actions */}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                    <Button 
                        onClick={() => {
                            setServiceAgentModalVisible(false);
                            setSelectedLeadForServiceAgent(null);
                            setSelectedServiceAgentForLead(null);
                        }} 
                        size="large"
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="primary" 
                        onClick={handleServiceAgentSave}
                        loading={savingServiceAgent}
                        size="large"
                        icon={<CheckOutlined />}
                    >
                        {selectedServiceAgentForLead ? 'Assign Agent' : 'Unassign Agent'}
                    </Button>
                </div>
            </>
        )}
    </div>
</Modal>
{/* Vehicle Specification Modal */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <FileTextOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Vehicle Specification</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Add or edit vehicle specifications
                </Text>
            </div>
        </div>
    }
    open={specificationModalVisible}
    onCancel={() => {
        setSpecificationModalVisible(false);
        setSelectedLeadForSpecification(null);
        setTempSpecification('');
    }}
    footer={[
        <Button 
            key="cancel" 
            onClick={() => {
                setSpecificationModalVisible(false);
                setSelectedLeadForSpecification(null);
                setTempSpecification('');
            }}
        >
            Cancel
        </Button>,
        <Button 
            key="submit" 
            type="primary" 
            onClick={handleSpecificationSave}
            loading={savingSpecification}
            icon={<CheckOutlined />}
        >
            Save Specification
        </Button>
    ]}
    width={600}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForSpecification && (
            <>
                {/* Customer & Vehicle Info Card */}
                <Card 
                    size="small" 
                    style={{ 
                        marginBottom: 20,
                        background: '#f5f5f5',
                        borderRadius: 12,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <Row gutter={[16, 8]}>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Customer</Text>
                            <div>
                                <Text strong>{selectedLeadForSpecification.personalInfo?.fullName || 'N/A'}</Text>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Vehicle</Text>
                            <div>
                                <Text strong>
                                    {selectedLeadForSpecification.vehicleInfo?.year || ''} {selectedLeadForSpecification.vehicleInfo?.make || ''} {selectedLeadForSpecification.vehicleInfo?.model || ''}
                                </Text>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Part</Text>
                            <div>
                                <Tag color="cyan">{selectedLeadForSpecification.vehicleInfo?.part || 'N/A'}</Tag>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Order Number</Text>
                            <div>
                                <Text strong code>{selectedLeadForSpecification.orderNumber || 'N/A'}</Text>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Specification Input */}
                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Specification Details:
                    </Text>
                    <Input.TextArea
                        placeholder="Enter vehicle specifications (e.g., engine type, transmission, color, features, condition, etc.)..."
                        value={tempSpecification}
                        onChange={(e) => setTempSpecification(e.target.value)}
                        rows={6}
                        maxLength={2000}
                        showCount
                        style={{ 
                            fontSize: '13px',
                            borderRadius: 8
                        }}
                        autoFocus
                    />
                    <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                        Include important details about the part/vehicle condition, compatibility notes, or special instructions.
                    </Text>
                </div>

                {/* Current Specification Preview (if exists) */}
                {selectedLeadForSpecification.vehicleInfo?.specification && (
                    <div>
                        <Divider style={{ margin: '12px 0' }} />
                        <div style={{ 
                            background: '#f0f8ff', 
                            padding: '12px', 
                            borderRadius: 8,
                            border: '1px solid #91d5ff'
                        }}>
                            <Space size={8} style={{ marginBottom: 8 }}>
                                <FileTextOutlined style={{ color: '#1890ff' }} />
                                <Text strong style={{ fontSize: 12 }}>Current Specification:</Text>
                            </Space>
                            <Text style={{ 
                                fontSize: '12px', 
                                display: 'block',
                                wordBreak: 'break-word',
                                whiteSpace: 'pre-wrap'
                            }}>
                                {selectedLeadForSpecification.vehicleInfo.specification}
                            </Text>
                        </div>
                    </div>
                )}
            </>
        )}
    </div>
</Modal>
        </div>
    );
};

export default AdvancePayment;

